module.exports = __webpack_public_path__ + "img/aws.8e24e627.svg";